import React, { ReactElement } from 'react';
import { useLocation } from 'react-router';
import { Heading } from 'idsk-react-components';
import Layout from '../Layout';
import { PripomienkaDetail, usePripomienkaDetail } from '../../module/PripomienkaDetail';
import ClassType from '../../model/pripomienka/ClassType';
import routes from '../../routing/routes';
import './pripomienkaDetailPage.scss';
import SecuredPage from '../../module/SecuredPage';

interface Props {
  classType: ClassType;
}

export default ({ classType }: Props): ReactElement => {
  const {
    reloadPripomienkaDetail,
    pripomienkaDetail,
    pripomienkaStatus,
  } = usePripomienkaDetail({ classType });
  const { pathname } = useLocation();

  return (
    <Layout
      isHromadna={classType === ClassType.HROMADNA_PRIPOMIENKA}
      breadcrumbRouteList={[{
        heading: routes.pripomienky.detail.name,
        to: pathname,
      }]}
    >
      <SecuredPage requestStatuses={[pripomienkaStatus?.responseCode]}>
        <div className="pripomienka-detail-page">
          <Heading size="l">
            Detail pripomienky
          </Heading>
          <PripomienkaDetail
            reloadPripomienkaDetail={reloadPripomienkaDetail}
            pripomienkaDetail={pripomienkaDetail}
            status={pripomienkaStatus}
            classType={classType}
          />
        </div>
      </SecuredPage>
    </Layout>
  );
};
